import {DEFAULT_COLOR} from '../../../globalVariables/GlobalVariables';
import useMobile from '../../../hooks/useMobile';
import PlusIconToPop from '../../../layout/plusIconToPop/PlusIconToPop';
import ColorAndImageTitle from './colorAndImageTitle/ColorAndImageTitle';
import MobilePopup from '../mobilePopup/MobilePopup';

function PopUpWithHeader({show, title, color=DEFAULT_COLOR, image, topChildren, children, dataCyName}) {
    const isMobile = useMobile();
    return (
        <MobilePopup close={show.close} showClass={show.showClass} dataCyName={dataCyName}>
            <>
                {isMobile && <PlusIconToPop show={show}/>}
                {topChildren}
                <ColorAndImageTitle color={color} image={image} text={title}/>
                {children}
            </>
        </MobilePopup>
    );
}

export default PopUpWithHeader;